import { SEARCH_RESULTS_SUCCESS, SEARCH_RESULTS_IS_LOADING, SEARCH_RESULTS_HAS_ERRORED, SEARCH_KEYWORD, SEARCH_CATEGORY_CONTENT, SEARCH_CATEGORY_CONTENT_IS_LOADING, SEARCH_CATEGORY_CONTENT_HAS_ERRORED, SEARCH_MAPPING_DATA_SUCCESS, SEARCH_MAPPING_IS_LOADING, SEARCH_MAPPING_HAS_ERRORED } from './types';
import { globalFetch } from './globalActions';
import { cysillCheck } from './CysillActions';

export function searchResultsSuccess(items, keywords) {

// TODO: refactor this code - creating cardItems is repeated several times across the app
	let resultItems = [];
	if(items.progs.length > 0) {

		let id, prog_link, title, programme_title, episodes, thumbnail="default.jpg", short_billing;

		Object.entries(items.progs).forEach(([key, value]) => {

			id = value.programme_id;
			prog_link = "/programme/"+id;
			title = value.series_title ? value.series_title : value.programme_title;
			programme_title = value.series_title ? value.programme_title : null;
			episodes = value.num_others;
			thumbnail = value.thumbnail_url;
			short_billing = value.short_billing;
			resultItems[key] = { id, prog_link, title, programme_title, episodes, thumbnail, short_billing };

		});
	}

	return {
		type: SEARCH_RESULTS_SUCCESS,
		payload: resultItems
	};
}

export function searchResultsRequest(keywords) {
	return globalFetch({
		urlPath: `search`,
		extraParams: `&q=${ keywords }`,
		reducerIsLoading: SEARCH_RESULTS_IS_LOADING,
		reducerError: SEARCH_RESULTS_HAS_ERRORED,
		dispatchSuccess: (itemObj, dispatch) => {
			dispatch(searchResultsSuccess(itemObj, keywords));
			if(itemObj.progs && itemObj.progs.length === 0){
				dispatch(cysillCheck(keywords))
			}
		}
	});
}

export function updateSearchKeyword(keyword) {
	return {
		type: SEARCH_KEYWORD,
		payload: keyword
	};
}

export function searchCategoryContent(cat) {
	if(cat.id && typeof cat.id !== "undefined") {
		return globalFetch({
				urlPath: `programme_feed_by_category`,
				extraParams: `&id=${ cat.id }`,
				reducerIsLoading: SEARCH_CATEGORY_CONTENT_IS_LOADING,
				reducerError: SEARCH_CATEGORY_CONTENT_HAS_ERRORED,
				dispatchSuccess: (itemObj, dispatch) => {
						dispatch(searchCategoryContentSuccess(itemObj, cat));
				}
		});
	} else {
		return {
			type: SEARCH_CATEGORY_CONTENT,
			payload: {}
		};
	}
}

function searchCategoryContentSuccess(data, cat) {

	function formatProgs(data) {
		let cardItems = [];
		if(data.length > 0)
		{
			let id, prog_link, title, programme_title, episodes, thumbnail="default.jpg", short_billing, value;

			for (let i = 0; i < data.length; i++) {
				value = data[i];
				id = value.id;
				prog_link = "/programme/"+value.id;
				title = value.series_title ? value.series_title : value.programme_title;
				programme_title = value.series_title ? value.programme_title : null;
				episodes = value.num_others;
				thumbnail = value.thumbnail_url;
				short_billing = value.short_billing;
				cardItems[i] = { id, prog_link, title, programme_title, episodes, thumbnail, short_billing };
			};
		}

		return cardItems;
	}

	let catData = {};
	if(Object.keys(data).length > 0 && Object.keys(cat).length > 0)
	{
		catData = {
				'id':  cat.id,
				'genre': cat.genre,
				'item': cat.item,
				'progs': formatProgs(data.progs.slice(0, 4))
			}
	}

	return {
		type: SEARCH_CATEGORY_CONTENT,
		payload: catData
	};
}


export function fetchCategoryMapping(lang) {
	return globalFetch({
			urlPath: `categoryMapping`,
			urlSrc: 1,
			reducerIsLoading: SEARCH_MAPPING_IS_LOADING,
			reducerError: SEARCH_MAPPING_HAS_ERRORED,
			dispatchSuccess: (itemObj, dispatch) => {
				dispatch({ type: SEARCH_MAPPING_DATA_SUCCESS, payload: itemObj[lang] });
			}
	});
}
